import * as Yup from "yup";
import React, { FunctionComponent } from "react";
import styles from "./ContactForm.module.scss";
import ContactFormProps from "./ContactFormProps";
import combineClasses from "helpers/combine-classes";
import Button from "components/Button/Button";
import { Formik, Field, Form, ErrorMessage } from "formik";

const ContactForm: FunctionComponent<ContactFormProps> = (props): JSX.Element => {
    return (
        <div>
            <Formik
                initialValues={{ name: "", email: "", phone: "", honeypot: "" }}
                validationSchema={Yup.object({
                    name: Yup.string().required("Enter your name"),
                    email: Yup.string().email("Enter valid email").required("Enter your email"),
                    phone: Yup.string().required("Enter your phone number"),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    if (values.honeypot === "") {
                        const to = props.content.emailRecipient;
                        const subject = encodeURIComponent(
                            `New contact form submission - ${props.selectedCity} (${props.content.activityName ? props.content.activityName : props.selectedActivity})`
                        );
                        const body = encodeURIComponent(
                            `Name: ${values.name}\nEmail: ${values.email}\nPhone: ${values.phone}\nCity: ${props.selectedCity}\nActivity: ${props.content.activityName ? props.content.activityName : props.selectedActivity}`
                        );

                        window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;

                        // Reset the form
                        resetForm();
                    }
                    setSubmitting(false);
                }}
            >
                {({ isValidating, isSubmitting, errors, touched }) => {
                    const nameAlertClass = errors.name && touched.name ? styles.alert : "";
                    const emailAlertClass = errors.email && touched.email ? styles.alert : "";
                    const phoneAlertClasss = errors.phone && touched.phone ? styles.alert : "";
                    return (
                        <Form className={styles.form}>
                            <>
                                {/* Name */}
                                <div className={styles.field_outer_wrapper}>
                                    <div className={styles.field_inner_wrapper}>
                                        <label
                                            htmlFor="name"
                                            className={styles.label}
                                        >
                                            {props?.content?.nameLabel || "Name"}
                                        </label>
                                        <Field
                                            name="name"
                                            id="name"
                                            type="text"
                                            placeholder="Name"
                                            className={combineClasses(styles.text_field, emailAlertClass)}
                                        />
                                    </div>
                                    {nameAlertClass ? (
                                        <div className={styles.alert_message}>
                                            <ErrorMessage name="name" />
                                        </div>
                                    ) : null}
                                </div>

                                {/* Email */}
                                <div className={styles.field_outer_wrapper}>
                                    <div className={styles.field_inner_wrapper}>
                                        <label
                                            htmlFor="email"
                                            className={styles.label}
                                        >
                                            {props?.content?.emailLabel || "Email"}
                                        </label>
                                        <Field
                                            name="email"
                                            id="email"
                                            type="text"
                                            placeholder="Email"
                                            className={combineClasses(styles.text_field, emailAlertClass)}
                                        />
                                    </div>
                                    {emailAlertClass ? (
                                        <div className={styles.alert_message}>
                                            <ErrorMessage name="email" />
                                        </div>
                                    ) : null}
                                </div>

                                {/* Phone */}

                                <div className={styles.field_outer_wrapper}>
                                    <div className={styles.field_inner_wrapper}>
                                        <label
                                            htmlFor="phone"
                                            className={styles.label}
                                        >
                                            {props?.content?.phoneLabel || "Phone"}
                                        </label>
                                        <Field
                                            name="phone"
                                            id="phone"
                                            type="text"
                                            placeholder="Phone"
                                            className={combineClasses(styles.text_field, phoneAlertClasss)}
                                        />
                                    </div>
                                    {phoneAlertClasss ? (
                                        <div className={styles.alert_message}>
                                            <ErrorMessage name="phone" />
                                        </div>
                                    ) : null}
                                </div>

                                {/* Honeypot */}
                                <div className={styles.field_outer_wrapper}>
                                    <div className={styles.field_inner_wrapper}>
                                        <label
                                            htmlFor="honeypot"
                                            className={styles.hidden_label}
                                        ></label>
                                        <Field
                                            type="text"
                                            name="honeypot"
                                            id="honeypot"
                                            className={styles.hidden_field}
                                        />
                                    </div>
                                </div>

                                {/* Submit button */}
                                {props.content.buttons && props.content.buttons.length > 0 ? (
                                    <div className={styles.buttons}>
                                        {props.content.buttons.map((button: any) => (
                                            <Button
                                                type="submit"
                                                key={button.contentUdi}
                                                to={button.content.link}
                                                className={styles.button}
                                                variant={button.content.variant}
                                                {...button.content}
                                            >
                                                {button.content.label}
                                            </Button>
                                        ))}
                                    </div>
                                ) : null}

                                {/* Loading */}
                                {isSubmitting ? <div className={styles.app_loading_spinner}></div> : null}
                            </>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default ContactForm;
